import request from 'api/request';
import { MenuItem } from 'types/Menu';
import { MINUTE } from 'utils/cache';

export const getCategoryList = async () => {
  return request<MenuItem[]>('GET', 'category-tree/', undefined, {
    cache: { makeKey: url => url, ttl: MINUTE * 5 },
  });
};
